import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumSalesTextType implements BaseEnumType {
  private static allValues: EnumSalesTextType[] = []; // make sure this is top-most
  
  public static pseudoAll = new EnumSalesTextType(65, "PseudoAll", "enum_sales_text_type_pseudo_all");
  public static brewery = new EnumSalesTextType(66, "Brewery", "enum_sales_text_type_brewery");
  public static accounts = new EnumSalesTextType(67, "Accounts", "enum_sales_text_type_accounts");
  public static driver = new EnumSalesTextType(68, "Driver", "enum_sales_text_type_driver");
  public static letter = new EnumSalesTextType(76, "Letter", "enum_sales_text_type_letter");
  public static rep = new EnumSalesTextType(82, "Rep", "enum_sales_text_type_rep");
  public static telesales = new EnumSalesTextType(84, "Telesales", "enum_sales_text_type_telesales");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumSalesTextType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isPseudoAll() { return this === EnumSalesTextType.pseudoAll; }
  public isBrewery() { return this === EnumSalesTextType.brewery; }
  public isAccounts() { return this === EnumSalesTextType.accounts; }
  public isDriver() { return this === EnumSalesTextType.driver; }
  public isLetter() { return this === EnumSalesTextType.letter; }
  public isRep() { return this === EnumSalesTextType.rep; }
  public isTelesales() { return this === EnumSalesTextType.telesales; }

  public static getValues(): readonly EnumSalesTextType[] {
    return EnumSalesTextType.allValues;
  }

  public static getValuesExcept0(): readonly EnumSalesTextType[] {
    return EnumSalesTextType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumSalesTextType {
    const found = EnumSalesTextType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSalesTextType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumSalesTextType): EnumSalesTextType {
    const found = name ? EnumSalesTextType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumSalesTextType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumSalesTextType>): boolean {
    return this.key === other?.key;
  }
}